import RecordClassCreator from "services/record";

export default class AnalyticsCount extends RecordClassCreator({
  type: "analyticsCount",

  /** @memberof AnalyticsCount# */
  dataType: null,
  /** @memberof AnalyticsCount# */
  value: null,

  /** @memberof AnalyticsCount# */
  valueType: null,

  /** @memberof AnalyticsCount# */
  label: null
}) {}
